/* istanbul ignore file */
import _ from 'underscore';
import { InlineEditableColumnPrompt } from '@bingads-webui-campaign/summary-grid-helper';
import { withUiBlock } from '@bingads-webui/uiblocker';
import odataSchemas from '@bingads-webui-campaign/campaign-ui-schemas';
import { triggerContainerResizing } from '@bingads-webui-campaign-react/virtual-scrollbar-recalculate-trigger';
import { localizeApiError } from './i18n-map/localize-api-errors';
import { ConversionRateInlineEditableColumnPrompt } from './conversion-rate-prompt';

const schema = odataSchemas.SeasonalityAdjustment;

function triggerScrollbarRepositionOnElementMount(selector, interval = 50) {
  const token = setInterval(() => {
    if (document.querySelector(selector)) {
      triggerContainerResizing();
      clearInterval(token);
    }
  }, interval);
}

function updateSeasonalityAdjustment({
  id,
  payload,
  jsdata,
  editorView,
  reloadGrid,
  i18n,
  getGridView,
  fieldName,
  adjustmentType,
}) {
  // update
  jsdata.SeasonalityAdjustment.update(id, payload, {
  }).then(() => {
    editorView.trigger('save');
    reloadGrid();
  }).catch((error) => {
    const errorMessage = localizeApiError(error, i18n, adjustmentType);
    editorView.setErrors({
      [fieldName]: errorMessage,
    });
  })
    .finally(withUiBlock(getGridView().$el));
}

function updateWithAssoicatedCamapign({
  id,
  payload,
  jsdata,
  editorView,
  reloadGrid,
  i18n,
  getGridView,
  fieldName,
  adjustmentType,
}) {
  // get associated campaigns if it is null
  jsdata.SeasonalityAdjustment.find(id, {
  }).then((response) => {
    const convertedCampaigns = response.CampaignAssociations;
    _.extend(payload, {
      CampaignAssociations: convertedCampaigns,
    });
    updateSeasonalityAdjustment({
      id,
      payload,
      jsdata,
      editorView,
      reloadGrid,
      i18n,
      getGridView,
      fieldName,
    }).catch((error) => {
      const errorMessage = localizeApiError(error, i18n, adjustmentType);
      editorView.setErrors({
        [fieldName]: errorMessage,
      });
    });
  });
}

export function inlineEditFactory({
  i18n,
  jsdata,
  getGridView,
  reloadGrid,
  adjustmentType,
}) {
  function onEditRate({ item, newPosition }) {
    const fieldName = 'AdjustmentPercentage';

    triggerScrollbarRepositionOnElementMount('.popup-editor');

    return ConversionRateInlineEditableColumnPrompt({
      item,
      newPosition,
      fieldName,
      i18n,
      saveModel: (updated, editorView) => {
        const id = item.Id;
        const payload = updated;
        if (payload.CampaignAssociationsCount > 0 && _.isEmpty(payload.CampaignAssociations)) {
          updateWithAssoicatedCamapign({
            id,
            payload,
            jsdata,
            editorView,
            reloadGrid,
            i18n,
            getGridView,
            fieldName,
            adjustmentType,
          });
        } else {
          updateSeasonalityAdjustment({
            id,
            payload,
            jsdata,
            editorView,
            reloadGrid,
            i18n,
            getGridView,
            fieldName,
            adjustmentType,
          });
        }
      },
    });
  }

  function onEditName({ item, newPosition: position }) {
    const fieldName = 'Name';

    triggerScrollbarRepositionOnElementMount('.popup-editor');

    return InlineEditableColumnPrompt({
      position,
      item,
      i18n,
      fieldName,
      schema,
      saveModel: (updated, editorView) => {
        const id = item.Id;
        const payload = updated;
        if (payload.CampaignAssociationsCount > 0 && _.isEmpty(payload.CampaignAssociations)) {
          updateWithAssoicatedCamapign({
            id,
            payload,
            jsdata,
            editorView,
            reloadGrid,
            i18n,
            getGridView,
            adjustmentType,
          });
        } else {
          updateSeasonalityAdjustment({
            id,
            payload,
            jsdata,
            editorView,
            reloadGrid,
            i18n,
            getGridView,
            adjustmentType,
          });
        }
      },
    });
  }

  return {
    onEditRate,
    onEditName,
  };
}
